import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button, Input, InputGroup, InputGroupAddon, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import useCopy from '../../../rewards/useCopy'
import CopyButton from '../../../rewards/components/CopyButton'

// HO-TASK-289: el backend devuelve el secreto del webhook solo al crear el
// aliado o al rotarlo; nunca en un listado. Se muestra una sola vez.
const SecretModal = ({ secret, partnerName, onClose }) => {
  const { copied, copy } = useCopy()
  const input = useRef(null)

  return (
    <Modal isOpen={!!secret} toggle={onClose} centered backdrop="static">
      <ModalHeader toggle={onClose}>Secreto del webhook · {partnerName}</ModalHeader>
      <ModalBody>
        <Alert color="warning" className="fs--1">
          <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
          Cópialo ahora y compártelo con el aliado por un canal seguro: <b>no se vuelve a mostrar</b>. Si se pierde,
          hay que generar uno nuevo.
        </Alert>
        <InputGroup size="sm">
          <Input
            innerRef={input}
            value={secret || ''}
            readOnly
            className="text-monospace"
            onFocus={(event) => event.target.select()}
            aria-label="Secreto del webhook"
          />
          <InputGroupAddon addonType="append">
            <CopyButton copied={copied === 'secret'} onClick={() => copy('secret', secret, input.current, 'Secreto copiado al portapapeles.')}>
              Copiar
            </CopyButton>
          </InputGroupAddon>
        </InputGroup>
        <p className="fs--2 text-600 mb-0 mt-2">
          El aliado firma cada evento con HMAC SHA-256 usando este secreto, en la cabecera X-Homelan-Signature.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" size="sm" onClick={onClose}>
          Ya lo guardé
        </Button>
      </ModalFooter>
    </Modal>
  )
}

SecretModal.propTypes = { secret: PropTypes.string, partnerName: PropTypes.string, onClose: PropTypes.func.isRequired }

export default SecretModal
